import { useMediaQuery } from "@mantine/hooks";

// The robotics bundle has no Tailwind and inline styles can't hold media
// queries, so views that need a different structure on phones branch on this.
export function useIsNarrow() {
  return useMediaQuery("(max-width: 640px)", false, { getInitialValueInEffect: false });
}
